import { observer } from 'mobx-react-lite';
import React from 'react';

import { useActiveElements } from './useActiveElements';

export const RootActiveElementsHost = observer(function RootActiveElementsHost() {
	const active = useActiveElements();
	const resolved = active.resolvedActive;

	if (!resolved) return null;

	const elementsToRender = [];

	active.stack.forEach((stackEntry, index) => {
		const registration = active.registry.get(stackEntry.name);
		if (!registration) return;

		elementsToRender.push({
			key: stackEntry.instanceId ?? `${stackEntry.name}-${index}`,
			Component: registration.Component,
			props: { ...(registration.defaultProps || {}), ...(stackEntry.props || {}) },
		});
	});

	elementsToRender.push({
		key: active.active?.instanceId ?? active.active?.name ?? 'active-element',
		Component: resolved.Component,
		props: resolved.props,
	});

	return (
		<>
			{elementsToRender.map((item) => (
				<item.Component key={item.key} {...{ ...item.props, onClose: active.closeActiveElement }} />
			))}
		</>
	);
});
